export enum SAEngineProjection {
    OPTIMISTIC = 'optimistic',
    CONSERVATIVE = 'conservative',
    EXPECTED = 'expected',
    MEDIAN = 'median',
    CUSTOM = 'custom',
}
